import { render, staticRenderFns } from "./DropdownLazy.vue?vue&type=template&id=47c4e8c3&"
import script from "./DropdownLazy.vue?vue&type=script&lang=js&"
export * from "./DropdownLazy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports